export const GET_BRANCHES = "get_branches";
export const CREATE_BRANCH = "create_branch";
export const EDIT_BRANCH = "edit_branch";
export const START_LOADING = "start_loading";
export const DELETE_BRANCH = "delete_branch";
export const STOP_LOADING = "stop_loading";
export const BRANCH_ERROR = "branch_error";
export const ACCESS_RIGHT_ERROR = "access_error";
